import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import {  createStructuredSelector } from 'reselect'
import { getProps, getProp, getSelect } from 'cape-select'
import { flow, get } from 'lodash/fp'
import { filter } from 'lodash'
// import { studentsFilled } from '../../select/student'
import { getProgramFull } from '../../select/program'
// import { artGraph, addStudentArt } from '../../select/art'
import { studentSlideArt, allStudentSlideArt } from "../../select/art";
import Component from './ProgramsDetailEl'
import { closePopup } from './back'

// export const getStudent = getSelect(
//   studentsFilled,
//   getProp('params.studentId'),
// )
// export const getEntity = createSelector(
//   artGraph,
//   getStudent,
//   addStudentArt
// )



  // reduce(
  //   students,
  //   (result, { art, id, name }) =>
  //     result.concat(
  //       map(art, item => ({ ...item, studentId: id, studentName: name }))
  //     ),
  //   []
  // );

export const getProgram = getSelect(
  getProgramFull,
  getProp('params.programId'),
)

const getProgramId = flow(getProps, get('params.programId'))

export const programArtOnly = slides => {
  // console.log(slides)
  // // const test = getProp('params.programId')
  // // console.log(props)
  // console.log(  getProps )
  // console.log(filter(slides, { 'program': getProgramId }))
  // return filter(slides, { 'program': "recn3KPre4Ccmkb5u" });
  return slides
}

// export const programStudentSlideArt = createSelector(allStudentSlideArt, programArtOnly);

export const getState = createStructuredSelector({
  program: getProgram,
  studentArt: studentSlideArt,
  allStudentArt: allStudentSlideArt,
})
export const actions = {
  closePopup,
}
export default connect(getState, actions)(Component)



// WEBPACK FOOTER //
// ./src/components/ProgramsDetail/ProgramsDetail.js